import { CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';
import { inject } from '@angular/core';

export const isDistrictAdminOrHigherGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const nav = inject(NavigationService);

	const isAdmin: boolean = await authService.isAdmin$();
	const isClientAdmin: boolean = await authService.isClientAdmin$();
	const isDistrictAdmin: boolean = await authService.isDistrictAdmin$();

	if (isAdmin || isClientAdmin || isDistrictAdmin) {
		return true;
	} else {
		nav.navigate(['/']);
		return false;
	}
};
